import ApiBuilder from '../helpers/ApiBuilder'
const { DEV_PORTAL_API } = ApiBuilder

const getAllApiResources = () => {
  return DEV_PORTAL_API.get(`/api/lookup/api-resources`)
}

const getAllApplicationCategories = () => {
  return DEV_PORTAL_API.get(`/api/lookup/app-category`)
}

const getProductPropertyFormats = (categoryName) => {
  return DEV_PORTAL_API.get(`/api/lookup/product-property-formats?categoryName=${categoryName}`)
}

const getAllPlatforms = () => {
  return DEV_PORTAL_API.get(`/api/lookup/platforms`)
}

export default {
  getAllApiResources,
  getAllApplicationCategories,
  getProductPropertyFormats,
  getAllPlatforms
}